import { translate } from "@escapio/shared/l10n/translate";

export const getTitle = (num, placeholder = num) =>
	num === 1
		? translate("list_favorites_heading_singular", placeholder)
		: translate("list_favorites_heading_plural", placeholder);
